<p class="b1 font-weight-semibold" fxLayout="row" fxFlex="20px" fxLayoutAlign="start center" vdw-ellipsis-label [text]="orderData.name" matTooltipPosition="above"></p>

<p class="b1 machine-quality-and-creel-name" fxLayout="row" fxFlex="20px" fxLayoutAlign="start center" vdw-ellipsis-label [text]="ellipsisLabelText" matTooltipPosition="above"></p>

<p class="b2 hint" *ngIf="orderData.dueDate" fxLayout="row" fxFlex="18px" fxLayoutAlign="start center" vdw-ellipsis-label [text]="dueDateAndPlannedAmountText" matTooltipPosition="above"></p>
<p class="b2 hint" *ngIf="!orderData.dueDate" fxLayout="row" fxFlex="18px" fxLayoutAlign="start center">
  {{ plannedAmountText }}
</p>
